import { FacebookIcon } from "@/components/footer/social-links";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps, REVIEW_URLS } from "../types";

export function FacebookReviewCard({ className }: PromotionalCardProps) {
	return (
		<PromotionalCardBase
			icon={<FacebookIcon className="w-full h-full" />}
			title="Join Us on Facebook"
			description="Get early access to new listings, tips & real estate insights"
			ctaText="Like Our Page"
			href={REVIEW_URLS.FACEBOOK}
			className={className}
			iconColor="text-[#1877F2]"
		/>
	);
}
